import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_security_operations.webp';
import "../solution.css"
const SecurityOperations = () => {
    return (
        <>

            <div
                className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                style={{ backgroundImage: `url(${backimg})` }}
            >
                <h1
                    style={{ wordSpacing: '8px' }} data-aos="fade-down"
                    className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-[100%] sm:w-full md:w-2/3 lg:w-[680px]"
                >
                    Unlock Security Excellence
                </h1>

                <p className="text-white text-sm w-full md:w-2/3 lg:w-[632px]" data-aos="fade-down">
                    Automate your IT, security, and risk workflows with Tekpossible's ServiceNow SecOps expertise. We help you maximize the platform's features to improve data and process collaboration, minimizing cybersecurity risk and driving resilience.
                </p>

                <Link
                    data-aos="zoom-in"
                    data-aos-delay="300"
                    to="/contact-us"
                    className="w-fit sm:w-[150px] md:w-[140px] lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                >
                    Contact Us
                </Link>
            </div>

            <div className="bg-[#FFFFFF] mt-6">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl">
                        How can ServiceNow SecOps solutions help you achieve your security goals?
                    </h1>
                </div>

                <div className="bg-white mb-10 mt-5">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 px-4 md:px-10 lg:px-10 py-5">

                        <div className="flex flex-col items-center text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-lg xl:text-xl font-semibold max-w-[253px]">
                                Accelerate Threat Response
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[350px]">
                                Accelerate threat investigations, bridge security gaps, and expedite incident response with AI-driven workflows and rich context, enabled by increased visibility.
                            </p>
                        </div>


                        <div className="flex flex-col items-center text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-lg xl:text-xl font-semibold max-w-[200px]">
                                Rapidly Adapt to Change
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[350px]">
                                Role-based dashboards provide clear security insights, facilitating proactive resource allocation and continuous improvement to safeguard your business.
                            </p>
                        </div>

                        <div className="flex flex-col items-center text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-xl lg:text-lg xl:text-xl font-semibold max-w-[253px]">
                                Evaluate Your Security Posture
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[350px]">
                                Gain clear, actionable security insights with role-based dashboards, empowering proactive resource allocation and continuous improvement to protect your business.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-down" data-aos-duration="1000" className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow SecOps Expertise
                    </h1>
                    <h5 data-aos="fade-up" data-aos-duration="1000" className="text-md text-black font-medium text-center max-w-[900px]">Security Incident Response | Vulnerability Response | Configuration Compliance | Threat Intelligence | Vulnerability Solution Management</h5>

                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-up" data-aos-duration="1000" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 max-w-[900px]">
                        Customize ServiceNow SecOps to meet your unique needs.
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default SecurityOperations;